import Vue from 'common/vue.common.js';
import WgComponent from 'WgUI/index.js';
import "WgUI/index.less";

export default {
    install() {
        for(let key in WgComponent) {
            Vue.component(key, Vue.extend(WgComponent[key]))
        }
    }
}